<template>
  <div class="admin-page">
    <admin-page-header
      eyebrow="Finans"
      title="Bankalar"
      description="Para çekim ve fatura akışlarında kullanılan banka kataloglarını yönetin."
    ></admin-page-header>
    <v-alert
      v-if="loadError"
      type="error"
      dense
      outlined
    >
      {{ loadError }}<v-btn
        text
        small
        @click="initialize"
      >
        Yeniden dene
      </v-btn>
    </v-alert>

    <v-card
      class="admin-table-card"
      outlined
    >
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="desserts"
        sort-by="calories"
        class="admin-data-table elevation-0"
      >
        <template v-slot:top>
          <v-toolbar
            dense
            :elevation="0"
            class="admin-page-toolbar"
          >
            <v-toolbar-title>Aktif banka listesi</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog
              v-model="bankDelete"
              persistent
              max-width="450px"
            >
              <delete-bank
                :close="closeBank"
                :save="deleteItem"
                :item="deleteItems"
                :helper-text="usageMessage"
                :disabled="usageBlocked"
              />
            </v-dialog>
            <v-dialog
              v-model="dialog"
              max-width="560px"
              persistent
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  small
                  v-on="on"
                >
                  Yeni Banka Bilgisi
                </v-btn>
              </template>
              <v-card class="admin-dialog-card">
                <v-toolbar
                  dense
                  :elevation="0"
                >
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                  <v-alert
                    v-if="formError"
                    type="error"
                    dense
                    outlined
                  >
                    {{ formError }}
                  </v-alert>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Ad"
                          placeholder="Banka adı"
                          outlined
                          dense
                          counter="50"
                          maxlength="50"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-file-input
                          v-model="editedItem.image"
                          accept="image/*"
                          label="Logo"
                          type="file"
                          outlined
                          dense
                          @change="onFileChange"
                        ></v-file-input>
                      </v-col>

                      <v-col
                        v-if="editedItem.image || imageUrl"
                        cols="12"
                      >
                        <v-card
                          outlined
                          class="admin-surface pa-4"
                        >
                          <v-img
                            :src="imageUrl"
                            max-height="140"
                            contain
                          ></v-img>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    :disabled="saving"
                    @click="close"
                  >
                    Çık
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saving"
                    :disabled="saving"
                    @click="save(editedItem)"
                  >
                    Kaydet
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template #[`item.logo.localUrl`]="{ item }">
          <v-avatar
            size="44"
            tile
          >
            <v-img
              max-height="100"
              max-width="100"
              :src="item.logo ? item.logo.localUrl : '-'"
            ></v-img>
          </v-avatar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            color="info"
            @click="editItem(item)"
          >
            {{ icons.mdiPencil }}
          </v-icon>
          <v-icon
            right
            small
            color="error"
            @click="openBank(item)"
          >
            {{ icons.mdiDelete }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { mdiDelete, mdiPencil } from '@mdi/js'
import { resolveApiErrorMessage } from '@/utils/apiErrors'
import { getAccessToken } from '@/utils/panelSession'
import AdminPageHeader from '@/components/admin/AdminPageHeader.vue'
import DeleteBank from './DeleteBank.vue'

const user = getAccessToken()

export default {
  components: {
    AdminPageHeader,
    DeleteBank,
  },
  data: () => ({
    dialog: false,
    bankDelete: false,
    deleteItems: {},
    loading: false,
    saving: false,
    formError: '',
    loadError: '',
    usageBlocked: true,
    usageMessage: '',
    imageUrl: '',
    headers: [
      { text: 'Eylemler', value: 'action' },
      {
        text: 'Logo', align: 'left', sortable: false, value: 'logo.localUrl',
      },
      {
        text: 'Ad', align: 'left', sortable: false, value: 'name',
      },
    ],
    desserts: [],
    requestOptions: {
      headers: { Authorization: `Bearer ${user}` },
    },
    icons: {
      mdiPencil,
      mdiDelete,
    },
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      image: '',
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Yeni Banka Ekle' : 'Banka Bilgisini Güncelle'
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close()
      }
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    createImage(file) {
      const reader = new FileReader()

      reader.onload = e => {
        this.imageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    onFileChange(file) {
      if (!file) return
      this.createImage(file)
    },
    initialize() {
      this.loading = true
      this.loadError = ''

      return axios
        .get(`${process.env.VUE_APP_BASE_API_URL}bank/list`, this.requestOptions)
        .then(response => {
          this.desserts = response.data.data
        })
        .catch(error => {
          this.loadError = resolveApiErrorMessage(error, 'Bankalar yüklenemedi.')
        })
        .finally(() => { this.loading = false })
    },
    editItem(item) {
      this.formError = ''
      this.editedIndex = item.id
      this.editedItem = { ...item }
      this.imageUrl = this.editedItem?.logo?.localUrl || ''
      this.dialog = true
    },
    closeBank() {
      this.bankDelete = false
    },
    async openBank(item) {
      this.bankDelete = true
      this.deleteItems = item
      this.usageBlocked = true
      this.usageMessage = 'Kullanım bilgisi kontrol ediliyor...'
      try {
        const response = await axios.get(`${process.env.VUE_APP_BASE_API_URL}bank/usage/${item.id}`, this.requestOptions)
        if (this.deleteItems.id !== item.id) return
        const count = response.data?.data?.linkedAccounts
        if (!Number.isInteger(count)) throw new Error('Invalid usage count')
        this.usageBlocked = count > 0
        this.usageMessage = `${count} bağlı banka hesabı.${count ? ' Kullanımdaki banka silinemez.' : ''}`
      } catch (error) { this.usageMessage = resolveApiErrorMessage(error, 'Kullanım bilgisi doğrulanamadı; silme kapalı.') }
    },
    async deleteItem(item) {
      await axios.delete(`${process.env.VUE_APP_BASE_API_URL}bank/deleteById/${item.id}`, this.requestOptions)
      this.desserts = this.desserts.filter(bank => bank.id !== item.id)
    },
    close() {
      if (this.saving) return
      this.dialog = false
      setTimeout(() => {
        if (this.dialog) return
        this.formError = ''
        this.editedItem = { id: '', name: '', image: '' }
        this.imageUrl = ''
        this.editedIndex = -1
      }, 300)
    },
    async save() {
      if (this.saving) return
      if (!String(this.editedItem.name || '').trim() || (this.editedIndex < 0 && !this.editedItem.image)) {
        this.formError = 'Banka adı ve yeni kayıtta logo zorunlu.'

        return
      }
      this.saving = true
      this.formError = ''
      const fd = new FormData()
      fd.append('name', this.editedItem.name.trim())
      if (this.editedItem.image) fd.append('image', this.editedItem.image)
      if (this.editedIndex > -1) fd.append('id', this.editedItem.id)
      try {
        await axios[this.editedIndex > -1 ? 'put' : 'post'](
          `${process.env.VUE_APP_BASE_API_URL}bank/${this.editedIndex > -1 ? 'update' : 'add'}`, fd, this.requestOptions,
        )
        this.saving = false
        this.close()
        await this.initialize()
      } catch (error) {
        this.formError = resolveApiErrorMessage(error, 'Banka kaydedilemedi.')
      } finally { this.saving = false }
    },
  },
}
</script>
